import {Component, forwardRef, Input} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FormControlBaseComponent} from "../../../../shared/components/form-controls/form-control-base/form-control-base.component";
import {AggregationGroupModel} from "../../../../shared/models/search/aggregations/aggregation-group.model";

@Component({
    selector: "pcg-ng-search-scope",
    template: require('./search-scope.component.html'),
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SearchScopeComponent), multi: true},
    ]
})
export class SearchScopeComponent extends FormControlBaseComponent<string> {
    @Input()
    public scopes: AggregationGroupModel;

    public constructor() {
        super(/*DEFAULT_VALUE*/"");
    }

    public handleClick(event: MouseEvent, scope: string): void {
        event.preventDefault();
        this.writeNewValue(scope);
    }
}
